<div class="modal-header modal-pepsico-header">
  <h1 class="modal-title fs-5" id="exampleModalLabel">CREA UNA NUEVA LISTA.</h1>
</div>
<div class="modal-body text-center">
  <div class="order-tracking-unique">
    <div #focusAnchor tabindex="-1" class="visually-hidden"></div>
    <form>
      <div class="mb-3">
        <label for="exampleInputEmail1" class="form-label">Nombre de la lista (obligatorio)</label>
        <input type="text" class="form-control" [formControl]=control maxlength="70"
          (keydown.enter)="$event.preventDefault()">
        @if(control.touched && control.invalid) {
        <div class="text-danger mt-2 fw-bold">
          @if(control.errors!['required']) {
          El nombre de la lista es requerida
          } @else if (control.errors!['minlength']) {
          La longitud mínima es de {{control.errors!['minlength']['requiredLength']}} caracteres.
          } @else if(control.errors!['maxlength']) {
          La longitud máxima es de {{control.errors!['maxlength']['requiredLength']}} caracteres.
          }
        </div>
        }
        <div class="form-text">Utiliza listas para guardar productos para más adelante.</div>
      </div>
    </form>
    <div class="d-flex jf-center">
      <button type="button" class="btn btn-primary perfilbtn-pep" (click)="closeModal()">Cancelar</button>
      <button type="button" class="btn btn-primary perfilbtn-pep" (click)="saveWishList()">Crear</button>
    </div>
  </div>
</div>
<div class="modal-footer ssd-nodec">
  <br><br>
</div>